var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tags"},[_c('span',{staticClass:"tag"},[_c('img',{attrs:{"src":require("../../assets/flag.svg"),"alt":"","width":"18","height":"18"}}),_vm._v(" "+_vm._s(_vm.pName)+" "),_c('b-skeleton',{attrs:{"active":_vm.pLoading,"width":"120"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }